/*
 * PasswordSetup Messages
 *
 * This contains all the text for the PasswordSetup component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.PasswordSetup";

export default defineMessages(scope, {
  changePassword: "change password",
  newPasswordLabel: "",
  changeButton: "Change",
  changeUsernameHeader: "Change your username",
  currentUsernameLabel: "Current username",
  changeSuccess: "You have successfully changed your {changedValue}.",
  enterPassword: "Enter Password",
  reEnterPassword: "Re-enter Password",
  updatePasswordButton: "Submit",
  errMsgRequiredField: "This field is required!",
  errMsgMaxLength: "Must be at least {changedValue} characters",
  errMsgUserName: "Must not contain part of your username",
  errMsgLastName: "Must not contain your last name",
  errMsgFirstName: "Must not contain your first name",
  errMsgLowerCase: "Must contain a lowercase letter",
  errMsgUpperCase: "Must contain an uppercase letter",
  errMsgSpecialChar: "Must contain a special character",
  errMsgNumber: "Must contain a number",
  errMsgUnconfirmedPassword: `Passwords do not match`,
  errMsgUnchangedUsername: `Your new username cannot be the same as your old username.`,
  genericErrorHeader: `Error`,
  genericErrorMessage: `Unable to update. Please try again later.`,
  confirmNewPasswordLabel: "",
  termsAgree: "I Agree",
  cancelButtonLabel: "Cancel",
  termsAndCondition: "Terms & Conditions",
  termsAndConditionHeader: "Terms and conditions",
  activationError: "Something went wrong, Please try again.",
});
